// extracted by mini-css-extract-plugin
module.exports = {"article":"Article_article__3OQcf","articleContent":"Article_articleContent__2Scn1","articleHead":"Article_articleHead__355uL"};